import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Let's Get Started`}</h2>
    <ProjectCard title="More About Me" link="http://www.maxwellabrams.com/home/about/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
  Learn a bit more about me!
    </ProjectCard>
    <ProjectCard title="Projects and Consulting" link="http://www.maxwellabrams.com/home/projects-and-consulting/" bg="linear-gradient(to right, #662D8C 0%, #ED1E79 100%)" mdxType="ProjectCard">
  See some of the things I have worked on.
    </ProjectCard>
    <ProjectCard title="Tech Blog" link="http://www.maxwellabrams.com/home/tech-blog/" bg="linear-gradient(to right, #009245 0%, #FCEE21 100%)" mdxType="ProjectCard">
  Where I post about things I find interesting!
    </ProjectCard>
    <ProjectCard title="Food & Travel" link="http://www.maxwellabrams.com/home/food-and-travel/" bg="linear-gradient(to right, #D585FF 0%, #00FFEE 100%)" mdxType="ProjectCard">
  Two of my favorite things! This is where I record some of my favorite places and restaurants.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      